module.exports = __webpack_public_path__ + "0dfa98aefca9f8683366bb04e66825be.pdf";